import React from 'react';

import ReportList from './ReportList';
import { getBillingDashboardPageBreadcrumb } from '../Billing/BillingDashboardPage';

import ProcessingIndicator from '../../Common/ProcessingIndicator';
import PageHeader from '../../Common/PageHeader';
import NavigationBreadcrumbs from '../../Common/NavigationBreadcrumbs';

import { getFacility } from '../../../Utils/facility';

import '../Page.scss';
import './ReportDashboardPage.scss';

class ReportDashboardPage extends React.Component {
  state = {
    pageInitializationComplete: false,
    pageInitializationErrors: [],
  };

  facilityId = null;
  facility = null;

  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const facilityId = urlSearchParams.get('facility');
    this.facilityId = (facilityId !== null) ? facilityId : null;
  }

  async componentDidMount() {
    try {
      if (this.facilityId !== null) {
        this.facility = await getFacility(this.facilityId);
      }

      this.setState({
        pageInitializationComplete: true
      });
    } catch (error) {
      const errors = Array.isArray(error) ? error : [error];

      this.setState({
        pageInitializationComplete: true,
        pageInitializationErrors: errors
      });
    }
  }

  renderNavigationBreadcrumbs() {
    const breadcrumbs = [];
    breadcrumbs.push(getBillingDashboardPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getReportDashboardPageBreadcrumb(true));

    return (
      <NavigationBreadcrumbs breadcrumbs={breadcrumbs} />
    );
  }

  renderPageHeader() {
    const heading = 'Reports Dashboard';
    const subheading = this.facility ? this.facility.fields.facility_name.value : null;
    const actions = [];

    return (
      <PageHeader heading={heading}
        subheading={subheading}
        actions={actions} />
    );
  }

  renderPageInitializationPanel() {
    const {
      pageInitializationComplete,
      pageInitializationErrors
    } = this.state;

    return (
      <div className="parkchirp--page--user-message-container">
        {(!pageInitializationComplete) &&
          <ProcessingIndicator userMessage="Initializing, please wait..." />
        }
        {(pageInitializationComplete && pageInitializationErrors.length > 0) &&
          <div className="parkchirp--page--user-message">
            <p>The following errors occurred while initializing the page:</p>
            <ul>
              {pageInitializationErrors.map(error =>
                <li key={performance.now()}>{error}</li>
              )}
            </ul>
          </div>
        }
      </div>
    );
  }

  render() {
    const {
      pageInitializationComplete,
      pageInitializationErrors
    } = this.state;
    return (
      <div className="parkchirp--page parkchirp--page--report-dashboard">
        {this.renderNavigationBreadcrumbs()}
        {this.renderPageHeader()}
        <div className="parkchirp--page-content">
          {(!pageInitializationComplete || pageInitializationErrors.length > 0) &&
            this.renderPageInitializationPanel()
          }
          {(pageInitializationComplete && pageInitializationErrors.length === 0) &&
            <ReportList facilityId={this.facilityId} />
          }
        </div>
      </div>
    );
  }
}

export default ReportDashboardPage;

export function getReportDashboardPageBreadcrumb(currentPage = true, facilityId = null) {
  const title = 'Report Dashboard';
  const href = (currentPage) ? null :
    `?page=parkchirp_reports${(facilityId !== null) ? `&facility=${facilityId}` : ''}`;

    return { title, href };
}